module.exports = __webpack_public_path__ + "img/razzo3.2e4221e1.webp";